import PropTypes from 'prop-types'

export const cost = PropTypes.shape({
  meta: PropTypes.shape({
    area_per_unit: PropTypes.number.isRequired,
    captures_per_unit: PropTypes.number.isRequired,
    cost_units: PropTypes.number.isRequired,
    cost_variable: PropTypes.string.isRequired,
  }).isRequired,
  totals: PropTypes.shape({
    project: PropTypes.object,
    plant_count: PropTypes.object,
    credit: PropTypes.object,
  }).isRequired,
})

export const pipelineProfiles = PropTypes.shape({
  orthomosaic: PropTypes.object,
  geotiff: PropTypes.object,
  individual_images: PropTypes.object,
  '3d': PropTypes.object,
})
